import { call, put, takeEvery } from 'redux-saga/effects'

import * as initAction from './initActions'

import InitServices from '../../services/InitService/initService'
import MyAvaliableOffers from '../../services/OffersService/MyAvaliableOffers'
import UserInformationServices from '../../services/ProfileService/UserInformationService'
import initTypes from './initTypes'

function * getEquipmentTypes () {
  try {
    const response = yield call(InitServices.getEquipmentTypes)
    yield put(initAction.getEquipmentTypesSuccess(response.data))
  } catch (error) {
    yield put(initAction.getEquipmentTypesFailure(error.message))
  }
}

function * getTimeZone () {
  try {
    const response = yield call(InitServices.getTimeZone)
    yield put(initAction.getTimeZoneSuccess(response.data))
  } catch (error) {
    yield put(initAction.getTimeZoneFailure(error.message))
  }
}

function * getHotOffers () {
  try {
    const res = yield call(MyAvaliableOffers.get, { offset: 0, filterBy: 'hot' })
    yield put(initAction.getHotOffersSuccess(res || {}))
  } catch (error) {}
}

function * getOffers () {
  try {
    const { results } = yield call(MyAvaliableOffers.get, { offset: 0, filterBy: 'available' })
    yield put(initAction.getOffersSuccess(results || 0))
  } catch (error) {}
}

function * getAvatar () {
  try {
    const { data } = yield call(UserInformationServices.getUserInformation)
    yield put(initAction.getAvatarSuccess(data.avatar))
  } catch ({ message }) {}
}

export function * initSaga () {
  yield takeEvery(initTypes.GET_EQUIPMENT_TYPES, getEquipmentTypes)
  yield takeEvery(initTypes.GET_TIMEZONE, getTimeZone)
  yield takeEvery(initTypes.GET_HOT_OFFERS, getHotOffers)
  yield takeEvery(initTypes.GET_OFFERS, getOffers)
  yield takeEvery(initTypes.GET_AVATAR, getAvatar)
}
